import { useTranslation } from '../context/TranslationContext';
import { translateWithFallback } from '../utils/translateWithFallback';
import LoadingSplash from './LoadingSplash';

type LoadingSpinnerProps = {
    /** Override label; defaults to state.loading → "Loading" */
    label?: string;
    /** Use full-viewport splash layout */
    fullScreen?: boolean;
};

const LoadingSpinner = ({ label, fullScreen = false }: LoadingSpinnerProps) => {
    const { t } = useTranslation();
    const text = label ?? translateWithFallback(t, 'state.loading', 'Loading');

    return (
        <LoadingSplash
            fullScreen={fullScreen}
            label={text}
            className={fullScreen ? undefined : 'h-64 min-h-0'}
        />
    );
};

export default LoadingSpinner;
